import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Purchase.module.sass";
import { ethers, providers, utils } from "ethers";
import { Link, useParams } from "react-router-dom";
import LandMarket from "../../abi/LandMarket.json";
import CapsuleMarket from "../../abi/CapsuleMarket.json";
import AssetMarket from "../../abi/Assets.json";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import CyberdogzMultiMarket from "../../abi/CyberdogzMultiMarket.json";
import CapsuleNFT from "../../abi/CapsuleNFT.json";
import ScooperMarket from "../../abi/Scooper.json";
import GemCardMarket from "../../abi/GemCardsMarket.json";
import { isMobile } from "react-device-detect";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import {
  getErrorMessage,
  injected,
  useEagerConnect,
  useInactiveListener,
} from "../../utils/connections";
import AccessoriesMarket from "../../abi/accessories.json";
import {
  ALCHEMY_PROVIDER_KEY,
  BONEZ_TOKEN_ADDRESS,
  COMMON_MARKET_ADDRESS,
  MATIC_ACCESSORIES_MARKET,
  TRANSFER_MARKET_ADDRESS,
} from "../../Config/config";
import TextInput from "../TransparentTextInput";
import BlackModal from "../BlackModal";

import DogzMarketJson from "../../abi/DogzMarket.json";
import CommonMarketJson from "../../abi/CommonMarket.json";
import ERC20Json from "../../abi/ERC20.json";
import TransferMarketJson from "../../abi/CyberdogzTransferMarket.json";

const Purchase = (props, { className }) => {
  const state = useSelector((state) => state);
  const { account, active, activate, deactivate, chainId } = useWeb3React();
  const [error, setError] = useState();
  const [quantity, setQuantity] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const [txHash, setTxHash] = useState("");
  const [usdPrice, setUSDPrice] = useState(0);
  const [signer, setSigner] = useState();
  const [provider, setProvider] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSelectWallet, setIsSelectWallet] = useState(false);
  const [btn_txt, setBtn_txt] = useState("BUY NOW");

  const wallet = async () => {
    try {
      if (!window.ethereum) {
        setIsSelectWallet(false);
        return;
      }
      activate(injected);
      setIsSelectWallet(false);
      if (account) {
      } else setError(error);
    } catch (err) {
      setIsSelectWallet(false);
      return setError(err.message);
    }

    setError("");
  };
  const getUSDPrice = () => {
    if (state.Usd.USD.length) {
      let usd = state.Usd.USD.find((element) => {
        return element.chainName == props.item.currency;
      });
      if (usd) setUSDPrice(usd.price);
    }
  };

  const getProvider = async () => {
    let provider = new ethers.providers.Web3Provider(window.ethereum);
    let signer = provider.getSigner();
    setProvider(provider);
    setSigner(signer);
  };

  const getWalletStatus = async () => {
    try {
      if (!window.ethereum) {
        setError("Metamask is not found.");
        return false;
      }
      if (!active) {
        setError("Please connect your wallet.");
        return false;
      }
      if (props.item.chainId === 1 && chainId !== 1) {
        setError("Please connect to Ethereum Mainnet");
        return false;
      }
      if (
        props.item.chainId === 137 ||
        (props.item.chainId === 10000 && chainId !== 137)
      ) {
        setError("Please connect to Polygon Mainnet");
        return false;
      }
      return active;
    } catch (e) {
      console.log(e);
      return false;
    }
  };
  const getEthbalanceCheck = async (currentPrice) => {
    try {
      let rawBalance = await provider.getBalance(account, "latest");
      let balance = utils.formatUnits(
        utils.parseUnits(rawBalance.toString(), "wei"),
        "ether"
      );
      if (parseFloat(balance) < parseFloat(currentPrice) * quantity) {
        setIsLoading(false);
        setBtn_txt("BUY NOW");
        setError("Insufficient Balance to complete the purchase");
        return false;
      }
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  };
  const buyLand = async () => {
    try {
      setBtn_txt("PROCESSING");
      let contract = new ethers.Contract(
        props.item.contractAddress,
        LandMarket.abi,
        signer
      );
      let currentPrice = await contract.getCurrentPrice(props.item.tokenId);
      let price = currentPrice[0].mul(quantity);
      currentPrice = utils.formatUnits(
        utils.parseUnits(currentPrice[0].toString(), "wei"),
        "ether"
      );
      if (!(await getEthbalanceCheck(currentPrice))) return;
      let estimatedGasLimit = await contract.estimateGas.buyToken(
        props.item.tokenId,
        quantity,
        { value: price }
      );
      let estimatedGasPrice = await provider.getGasPrice();
      let overrides = {
        gasLimit: estimatedGasLimit,
        gasPrice: estimatedGasPrice,
        value: price,
      };
      let token = await contract.buyToken(
        props.item.itemId,
        quantity,
        overrides
      );
      setTxHash(token.hash);
      let receipt = await token.wait();
      if (receipt.status !== 1) {
        setError("Purchase failed.");
        setIsLoading(false);
        setBtn_txt("BUY NOW");
        return false;
      }
      setIsSuccess(true);
      setIsLoading(false);
      setBtn_txt("BUY NOW");
    } catch (e) {
      console.log(e);
      setError("Purchase failed.");
      setIsLoading(false);
      setBtn_txt("BUY NOW");
      return;
    }
  };
  const buyToken = async () => {
    setError("");
    setIsSuccess(false);
    setTxHash("");
    if (!(await getWalletStatus())) return;

    try {
      setIsLoading(true);
      if (props.item.assetType.type === "dog" && props.item.status === "LIVE") {
        let contract = new ethers.Contract(
          props.item.contractAddress,
          DogzMarketJson.abi,
          signer
        );
        let currentPrice = await contract.getCurrentPrice(props.item.itemId);
        let price = currentPrice[0].mul(quantity);
        currentPrice = utils.formatUnits(
          utils.parseUnits(currentPrice[0].toString(), "wei"),
          "ether"
        );
        if (!(await getEligibility(currentPrice, price))) return;

        setBtn_txt("PROCESSING");

        let estimatedGasLimit = await contract.estimateGas.buyToken(
          props.item.itemId,
          quantity
        );
        let estimatedGasPrice = await provider.getGasPrice();
        let overrides = {
          gasLimit: estimatedGasLimit,
          gasPrice: estimatedGasPrice,
        };
        let token = await contract.buyToken(
          props.item.itemId,
          quantity,
          overrides
        );
        setTxHash(token.hash);
        let receipt = await token.wait();
        if (receipt.status !== 1) {
          setError("Purchase failed.");
          return false;
        }
        setIsSuccess(true);
        setIsLoading(false);
        setBtn_txt("BUY NOW");
      } else if (props.item.assetType.type === "land") {
        await buyLand();
      } else if (props.item.contractAddress === COMMON_MARKET_ADDRESS) {
        let contract = new ethers.Contract(
          props.item.contractAddress,
          CommonMarketJson.abi,
          signer
        );
        let currentPrice = await contract.getCurrentPrice(
          props.item.nftContractAddress,
          props.item.itemId
        );
        let price = currentPrice[0].mul(quantity);
        currentPrice = utils.formatUnits(
          utils.parseUnits(currentPrice[0].toString(), "wei"),
          "ether"
        );
        if (!(await getEligibility(currentPrice, price))) return;
        setBtn_txt("PROCESSING");

        let estimatedGasLimit = await contract.estimateGas.buyToken(
          props.item.nftContractAddress,
          props.item.itemId,
          quantity
        );
        let estimatedGasPrice = await provider.getGasPrice();
        let overrides = {
          gasLimit: estimatedGasLimit,
          gasPrice: estimatedGasPrice,
        };
        let token = await contract.buyToken(
          props.item.nftContractAddress,
          props.item.itemId,
          quantity,
          overrides
        );
        setTxHash(token.hash);
        let receipt = await token.wait();
        if (receipt.status !== 1) {
          setError("Purchase failed.");
          setBtn_txt("BUY NOW");
          setIsLoading(false);
          return false;
        }
        setIsSuccess(true);
        setIsLoading(false);
        setBtn_txt("BUY NOW");
      } else if (props.item.contractAddress === TRANSFER_MARKET_ADDRESS) {
        let contract = new ethers.Contract(
          props.item.contractAddress,
          TransferMarketJson.abi,
          signer
        );
        let currentPrice = await contract.getCurrentPrice(
          props.item.nftContractAddress,
          props.item.itemId
        );
        let price = currentPrice[0].mul(quantity);
        currentPrice = utils.formatUnits(
          utils.parseUnits(currentPrice[0].toString(), "wei"),
          "ether"
        );
        if (!(await getEligibility(currentPrice, price))) return;
        setBtn_txt("PROCESSING");

        let estimatedGasLimit = await contract.estimateGas.buyToken(
          props.item.nftContractAddress,
          props.item.itemId,
          quantity
        );
        let estimatedGasPrice = await provider.getGasPrice();
        let overrides = {
          gasLimit: estimatedGasLimit,
          gasPrice: estimatedGasPrice,
        };
        let token = await contract.buyToken(
          props.item.nftContractAddress,
          props.item.itemId,
          quantity,
          overrides
        );
        setTxHash(token.hash);
        let receipt = await token.wait();
        if (receipt.status !== 1) {
          setError("Purchase failed.");
          return false;
        }
        setIsSuccess(true);
        setIsLoading(false);
        setBtn_txt("BUY NOW");
      } else {
        setError("Token not buyable.");
        setBtn_txt("BUY NOW");
        setIsLoading(false);
      }
    } catch (e) {
      setError("Purchase failed.");
      setBtn_txt("BUY NOW");
      setIsLoading(false);
      console.log(e);
    }
  };

  const getEligibility = async (currentPrice, price) => {
    if (!(await getWalletStatus())) return;

    try {
      setBtn_txt("APPROVING");
      let contract = new ethers.Contract(
        BONEZ_TOKEN_ADDRESS,
        ERC20Json,
        signer
      );
      let balance = await contract.balanceOf(account);
      balance = parseFloat(ethers.utils.formatEther(balance));
      if (parseFloat(currentPrice) * quantity > balance) {
        setError("Insuffcient BONEZ balance.");
        setBtn_txt("BUY NOW");
        setIsLoading(false);
        return false;
      }
      let allowance = await contract.allowance(
        account,
        props.item.contractAddress
      );
      allowance = parseFloat(ethers.utils.formatEther(allowance));
      if (allowance >= parseFloat(currentPrice)) {
        return true;
      }
      let approve = await contract.approve(props.item.contractAddress, price);
      let receipt = await approve.wait();
      if (receipt.status !== 1) {
        setError("BONEZ approval failed.");
        setBtn_txt("BUY NOW");
        setIsLoading(false);
        return false;
      }
      return true;
    } catch (e) {
      console.log(e);
      setError("BONEZ approval failed.");
      setBtn_txt("BUY NOW");
      setIsLoading(false);
      return false;
    }
  };

  useEffect(() => {
    getUSDPrice();
  }, [state.Usd.USD]);

  useEffect(() => {
    getProvider();
  }, [active, chainId]);
  return (
    <>
      <div className={cn(className, styles.connect)}>
        <h3 className={styles.title}>{props.item.name}</h3>

        <div className={styles.item}>
          {props.item.attachments[0].fileType == "IMAGE" ? (
            <img
              src={props.item.previewImage}
              alt="Card"
              className={styles.image}
            />
          ) : (
            <video
              autoPlay={deviceWidth > 1005}
              muted
              loop={deviceWidth > 1005}
              src={props.item.attachments[0].url}
              type="video/mp4"
              controls
              poster={props.item.attachments[1].url}
              className={styles.image}
              controlsList="nodownload"
            />
          )}
          <div className={styles.text}>
            <div className={styles.info}>
              <div>
                <label className={styles.head}>Price</label>
                <span className={styles.price}>
                  <NumberFormat
                    value={props.item.tokenPrice.toFixed(2).toLocaleString()}
                    displayType={"text"}
                    thousandSeparator={true}
                  />{" "}
                  {props.item.currency}
                </span>
                {usdPrice ? (
                  <span className={styles.note}>
                    {(usdPrice * props.item.tokenPrice).toFixed(2)} USD
                  </span>
                ) : null}
              </div>

              <div>
                <TextInput
                  className={styles.field}
                  label="Quantity"
                  name="Item"
                  type="number"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  placeholder="Enter Quantity"
                  min="1"
                />
              </div>

              <div>
                <label className={styles.head}>You will pay</label>
                <span className={styles.price}>
                  <NumberFormat
                    value={(props.item.tokenPrice * quantity)
                      .toFixed(2)
                      .toLocaleString()}
                    displayType={"text"}
                    thousandSeparator={true}
                  />{" "}
                  {props.item.currency}
                </span>
                {usdPrice ? (
                  <label className={styles.note}>
                    {(usdPrice * props.item.tokenPrice * quantity).toFixed(2)}{" "}
                    USD
                  </label>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        {error && <div className={styles.alert}>{error}</div>}
        {isSuccess && (
          <div className={styles.success} style={{ color: "#45B26B" }}>
            {" "}
            <div>You have bought the asset successfully.</div>
          </div>
        )}

        <div className={styles.btns}>
          {btn_txt == "PROCESSING" ? (
            <button className={cn("button", styles.button)}>
              {btn_txt}
              {isLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  style={{ marginLeft: "8px" }}
                  size="sm"
                  className={styles.spinner}
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          ) : (
            <button
              className={cn("button", styles.button)}
              onClick={() => {
                buyToken();
              }}
            >
              {btn_txt}
              {isLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  style={{ marginLeft: "8px" }}
                  size="sm"
                  className={styles.spinner}
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          )}

          {txHash && (
            <div className={styles.success}>
              Transaction submitted.{" "}
              <a
                href={
                  props.item.chainId == 1
                    ? "https://etherscan.io/tx/" + txHash
                    : "https://polygonscan.com/tx/" + txHash
                }
                target="_blank"
              >
                View in explorer
              </a>
            </div>
          )}
          {props.item.chainId !== 1 && (
            <div className="mt-2">
              <span className={styles.notice}>important notice: </span>
              <li>
                You would approve the transaction in metamask before confirming
                the purchase.
              </li>
            </div>
          )}
        </div>
      </div>

      <BlackModal
        visible={isSelectWallet}
        onClose={() => setIsSelectWallet(false)}
      >
        <div className={styles.modal}>
          <div className={cn("h4")}>Connect Wallet</div>
          <br />
          <div>
            Please connect your wallet to continue.
            <br /> The system supports the following wallets
            <br />
            <br />
          </div>
          <div
            className={styles.wallet}
            onClick={() => {
              if (isMobile && !window.ethereum) {
                window.location =
                  "https://metamask.app.link/dapp/cyberdogz.io/detail/" +
                  props.item._id;
              } else {
                wallet();
              }
            }}
          >
            <img
              className={styles.metamask}
              src="data:image/svg+xml;base64,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"
            />
            MetaMask
            <img
              className={styles.iconimg}
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAyMTUgOC42NDVMMTUuMzY0OCAxNEwxMC4wMjE1IDE5LjM1NUwxMS42NjY1IDIxTDE4LjY2NjUgMTRMMTEuNjY2NSA3TDEwLjAyMTUgOC42NDVaIiBmaWxsPSIjNzc3RTkwIi8+Cjwvc3ZnPgo="
            />
          </div>
        </div>
      </BlackModal>
    </>
  );
};

export default Purchase;
